module.exports = {"brand":"보이스캐디","clubName":"해비치 컨트리클럽 서울"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/intro.json
// module id = EWNR
// module chunks = 2